import React from "react";
import { CAPTCHA_NOTICE_URL } from "../captcha";

function CaptchaNotice() {
  return (
    <p className="text-center text-[11px] leading-snug text-gray-400 dark:text-gray-500">
      Форма защищена Yandex SmartCaptcha.{" "}
      <a
        href={CAPTCHA_NOTICE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-gray-500 dark:hover:text-gray-400"
      >
        Условия обработки данных
      </a>
    </p>
  );
}

export default CaptchaNotice;
